module.exports = __webpack_public_path__ + "static/media/video_3.17a28d73.mp4";